import React from 'react';
import { InstructionWidget } from '@/pages/essay/essay-about/essay-about-instruction';
import signature from '@/assets/images/signature.svg';
import photoCellPhone from '@/assets/images/photo-cell-phone.svg';
import essayText from '@/assets/images/essay-text.png';
import { DialogTitle } from '@/components/ui/dialog';
import { WidgetInstructionWrapper } from '@/components/custom/widget';

export function EssayAboutTips({ essayId }) {
  const instructions = [
    {
      number: 1,
      title: 'Escreva sua redação',
      description: 'Baixe e imprima nossa folha no botão abaixo ou utilize um folha pautada no tamanho A4.',
      img: signature,
      cta: {
        text: 'Baixar folha',
        to: `/redacao/impressao/${essayId}`
      }
    },
    {
      number: 2,
      title: 'Tire foto da redação para que ela seja digitalizada e envie pelo botão abaixo, mas antes atente para algumas instruções: ',
      description: [
        'Faça um bom enquadramento e ajuste o foco da câmera;',
        'Não corte as linhas que limitam o espaço da redação;',
        'Escolha um lugar plano e claro para tirar a foto; ',
        'Escreva com letra legível e evite  rasuras e;',
        'Padronize os espaços entre as palavras.'
      ],
      type: 'list',
      img: photoCellPhone
    },
    {
      number: 3,
      title: 'Revise o texto que foi digitalizado',
      description: 'Verifique se o texto que você escreveu foi digitalizado corretamente. Se precisar editar, você pode clicar no texto e fazer a correção. Quando tudo estiver certo, clique em “Enviar para correção”. ',
      img: essayText
    }
  ];

  return (
    <>
      <DialogTitle>Como enviar minha redação?</DialogTitle>

      <WidgetInstructionWrapper>
        {instructions.map(item => (
          <InstructionWidget
            key={item.id}
            data={item}
          />
        ))}
      </WidgetInstructionWrapper>
    </>
  );
}
